import request from "@/utils/request";

export default function agentGetAccessControlInfoByQrcodeId(qrcodeId) {
  return request.get(
    `/device/common/device/getDeviceInfoByQrCodeId/${qrcodeId}`
  );
}
